import Curl from '$common/utils/curl/browser-curl';
import UrlModules from '$common/utils/curl/browser-curl/url-modules';
import AppCurl from '$common/utils/curl/app-curl';

export const isWownowApp = navigator.userAgent.toLowerCase().indexOf("wownow") !== -1;
export const appgatewayHost = new UrlModules({ module: 'appgateway' });
export const defaultCurl = (params, url, config) => new Curl().curl(params, `${appgatewayHost.host}/gateway_web/${url}`, config);
const defaultAppCurl = (params, url, config) => new AppCurl().curl(params, `/${url}`, config);

let taskPost = []
let isInjectionTime = false
setTimeout(() => {
  isInjectionTime = true
  if (taskPost.length) {
    taskPost.forEach(task => {
      curlGateWay(task.params, task.url, task.config).then(res => task.resolve(res)).catch(res => task.reject(res))
    })
    taskPost = []
  }

}, 2000)

//  封装统一的请求
export const curlGateWay = (params, url, config) => {
  try {
    if (isWownowApp) {
      return new Promise((resolve, reject) => {
        if (!isInjectionTime) {
          taskPost.push({ resolve, reject, params, url, config })
          return false
        }
        const legalParams = getLegalParams(params)
        console.log('发起APP请求', legalParams)
        defaultAppCurl(legalParams, url, {
          success: (res) => {
            console.log('发起APP响应数据', res)
            resolve({ data: res })
          },
          fail: (e) => {
            reject(e)
          }
        })
      })
    }
    return defaultCurl(params, url, config);
  } catch (error) {
    console.log(`请求有异常`, error)
  }
}

// 防止提交不合法的请求参数，app拒绝发起请求
export const getLegalParams = function (data) {
  let params = {}
  if (data && typeof data == 'object') {
    for (const x in data) {
      const val = data[x]
      if (val !== undefined && val !== null) {
        params[x] = val
      }
    }
  }
  return params
}
